import React from "react";
import { ReactComponent as AdminFunctionIcon } from "../../../Assets/NewIconsForCards/UserSettingsIcon.svg";
import { ReactComponent as StationIcon } from "../../../Assets/NewIconsForCards/StationIcon.svg";
import Card from "../../Components/Card";
import { useNavigate } from "react-router-dom";

const Arr = [
  {
    title: "Logistic Station General",
    text: "",
    Icon: StationIcon,
    link: "/LogisticStationGeneral",
  },
  {
    title: "Admin Function",
    text: "",
    Icon: AdminFunctionIcon,
    link: "/LogisticStationAdmin",
  },
];

export default function LogisticStationOverview(props) {
  return (
    <div className="mainContainer">
      <div className="overviewCardContainer">
        {Arr.map((record, i) => (
          <Card {...record} key={i} />
        ))}
      </div>
    </div>
  );
}
